/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { Injectable } from '@angular/core'

@Injectable()
export class UtilsService {

  public maskPhoneNumber(value: string): string {
    let newVal: string
    if (value.length === 0) {
      newVal = ''
    } else if (value.length <= 3) {
      newVal = value.replace(/^(\d{0,3})/, '($1)')
    } else if (value.length <= 6) {
      newVal = value.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2')
    } else if (value.length <= 10) {
      newVal = value.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3')
    } else {
      newVal = value.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3')
    }
    return newVal
  }
}
